import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[ivNumericDirective]'
})

export class NumericDirective implements OnInit {

  @Input('ivNumericDirective') currencyOptions;

  constructor(private elementRef: ElementRef) { }

  ngOnInit(): void {
  }

  @HostListener('focus') onFocus() {
    if (this.elementRef.nativeElement.value === '$0.00' || this.elementRef.nativeElement.value === '0.00' || this.elementRef.nativeElement.value === '0') {
      this.elementRef.nativeElement.value = '';
    }
  }

  @HostListener('blur') onBlur() {
    const val = this.elementRef.nativeElement.value;
    const decimalPos = val.indexOf(this.currencyOptions.decimalSeparator);
    if (val) {
      if (decimalPos === -1) {
        if (this.currencyOptions.precision > 0) {
          this.elementRef.nativeElement.value += this.currencyOptions.decimalSeparator + '00';
        } else {
          this.elementRef.nativeElement.value;
        }
      }
    } else {
      if (this.currencyOptions.precision > 0 && val) {
        this.elementRef.nativeElement.value += '0' + this.currencyOptions.decimalSeparator + '00';
      } else {
        this.elementRef.nativeElement.value;
      }
    }
  }
}
